import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { HospitalService } from '../hospital.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-hospital-register',
  templateUrl: './hospital-register.component.html',
  styleUrls: ['./hospital-register.component.css']
})
export class HospitalRegisterComponent implements OnInit {

  isUpdate=false;
  hosData
  rdForm: FormGroup;
  token: string;
  id: any;
  path = 'https://api.doqmatokens.com/';
  
  ShowDelete:boolean=false;
  // for add image
  hospitalImagesArray: FormArray;
  cForm: any;
  filesToUpload: Array<File> = [];
  fd: FormData;
  fileSelected
  hosId
  hosImageTitle: any;
  // end add image

  constructor(private hospitalService:HospitalService,private activatedRoute:ActivatedRoute,private authService:AuthService,
    private router:Router) { }

  ngOnInit() {

    this.id = this.activatedRoute.snapshot.queryParams["id"];
   
    if (this.id) {
      this.isUpdate = true;
    }
    this.authService.authDataSubject.pipe(take(1)).subscribe(res => {
      this.token = res._token;
    });
    if (this.isUpdate) {
      this.getSingleHospital();
    }
    if (!this.rdForm) {
      this.oninitForm();
    }
    this.onInitForm();
  }
  getSingleHospital() {
    this.hospitalService
    .getSingleHospital(this.id, this.token)
    .subscribe(res => {
      this.hosData = res.data;
      this.oninitForm();
      console.log(res);
      
      
      // this.hospitalImagesArray = res.data.hospitalImages;
    });
  }





  oninitForm() {
    const name = this.hosData ? this.hosData.name : null;
    const email = this.hosData ? this.hosData.email : null;

    const website = this.hosData ? this.hosData.website : null;

    const line1 = this.hosData ? this.hosData.address.line1 : null;
    const city = this.hosData ? this.hosData.address.city : null;
    const pincode = this.hosData ? this.hosData.address.pincode : null;
    const state = this.hosData ? this.hosData.address.state : null;

    const phoneNo = this.hosData ? this.hosData.phoneNo : null;
    const rating = this.hosData ? this.hosData.rating : null;
    const description = this.hosData ? this.hosData.description : null;


 /* if (this.isUpdate) {
      this.rdForm = new FormGroup({
        name: new FormControl(name, Validators.required),
        website: new FormControl(null, Validators.required),
        email: new FormControl(email, [Validators.required, Validators.email]),
       // password: new FormControl(null, Validators.required),
        startTime: new FormControl(null, Validators.required),
        gender: new FormControl(null, Validators.required),

        line1: new FormControl(line1, Validators.required),
        city: new FormControl(city, Validators.required),
        pincode: new FormControl(pincode, [
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/)
        ]),
        state: new FormControl(state, Validators.required),

        endTime: new FormControl(null, Validators.required),
        phoneNo: new FormControl(phoneNo, [
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          Validators.minLength(10)
        ])
      });
    }*/
  //  else {
      this.rdForm = new FormGroup({
        name: new FormControl(name, Validators.required),
        email: new FormControl(email, [Validators.required, Validators.email]),
        password: new FormControl(null, Validators.required),
        website: new FormControl(website, Validators.required),
        startTime: new FormControl(null, Validators.required),
        endTime: new FormControl(null, Validators.required),
        description: new FormControl(description, Validators.required),
        rating:new FormControl(rating),
        line1: new FormControl(line1, Validators.required),
        city: new FormControl(city, Validators.required),
        pincode: new FormControl(pincode, [
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/)
        ]),
        state: new FormControl(state, Validators.required),


        phoneNo: new FormControl(phoneNo, [
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          Validators.minLength(10)
        ])
      });

      //   }
  }
  onSubmit(){
    const name = this.rdForm.value["name"];
    const website = this.rdForm.value["website"];
    const email = this.rdForm.value["email"];
    const password = this.rdForm.value["password"];

    const line1 = this.rdForm.value["line1"];
    const city = this.rdForm.value["city"];
    const pincode = this.rdForm.value["pincode"];
    const state = this.rdForm.value["state"];
    const startTime=  this.rdForm.value["startTime"];
    const endTime=  this.rdForm.value["endTime"];

    const description = this.rdForm.value["description"];
    const phoneNo = this.rdForm.value["phoneNo"];
    const rating = this.rdForm.value["rating"];
    if(!this.isUpdate){
  this.hospitalService.saveHospitalToDatabase(name,email,password,website,phoneNo,rating,startTime,endTime,description,line1,city,state,pincode,this.token).subscribe(res=>{
    this.router.navigate(["../"], {
      relativeTo: this.activatedRoute
    });
  })
}else{
  this.hospitalService.updateHospitalToDatabase(name,email,website,phoneNo,rating,startTime,endTime,
    description,line1,city,state,pincode,this.token,this.id).subscribe(res=>{
      this.router.navigate(["../"], {
        relativeTo: this.activatedRoute
      });
    })
}
  
  /*
   const name = this.ptForm.value["name"];
    const email = this.ptForm.value["email"];
    const password = this.ptForm.value["password"];

    const query = this.ptForm.value["query"];

    const phoneNo = this.ptForm.value["phoneNo"];
    if (this.isUpdate) {
      this.patientsService
        .updatePatientsToDb(
          name,
          email,
          password,
          query,
          phoneNo,
          this.token,
          this.id
        )
        .subscribe(
          res => {
            this.router.navigate(["../"], {
              relativeTo: this.activatedRoute
            });
          },
          err => {
            this.messageService.add({
              key: "tc",
              severity: "success",
              summary: "Update Failed",
              detail: "check your internet connection"
            });
          }
        );
    } else {
      this.patientsService
        .savePatientsToDb(name, email, password, query, phoneNo, this.token)
        .subscribe(
          res => {
            this.router.navigate(["../"], {
              relativeTo: this.activatedRoute
            });
          },
          err => {
            this.messageService.add({
              key: "tc",
              severity: "success",
              summary: "Registration Failed",
              detail: "check your internet connection"
            });
          }
        );
    }
  */
  }

  // for add image
  onAddFormImagesArray(){
    this.hospitalImagesArray.push(
      new FormGroup({
        imagetitle: new FormControl(null,Validators.required),
        image: new FormControl(null,Validators.required),
      })
    );
    console.log("this is images array",this.hospitalImagesArray);
    
  }

  onRemoveImagesArray(i){
    if(i>0){
this.hospitalImagesArray.removeAt(i)
     this.filesToUpload.splice(i,1)
    }
    
    
  }
onInitForm(){
  this.hospitalImagesArray = new FormArray([
    new FormGroup({
      imagetitle: new FormControl(null,Validators.required),
      image: new FormControl(null,Validators.required),
    }),
  ]);
  this.cForm = new FormGroup({
   
    hosVideo: this.hospitalImagesArray,

  });
}
 

get controls() {
  return (this.cForm.get("hosVideo") as FormArray).controls;
}

onAddFormArray() {
 
}
onRemovesyllabusArray(i) {
}
onChangeProfile(event){
  this.fileSelected = <File>event.target.files[0];
  console.log("this is file",this.fileSelected.size);
  if(this.fileSelected.size < 2000000){
    this.filesToUpload = [];
    this.filesToUpload.push(this.fileSelected);
    alert("success")
  }else{
    alert("that image is too large to upload it!")
  }
  
//this.fd.append('profileimage',fileSelected,fileSelected.name)
console.log("this is files of image",this.filesToUpload);

}
onSubmitImg(){
   const hosImageTitle = this.cForm.value["hosVideo"]
  
  console.log( hosImageTitle);
  console.log("this is fileto upload",this.filesToUpload);
  
if(hosImageTitle.length===this.filesToUpload.length){
  this.hospitalService.addHospitalImages(hosImageTitle,this.filesToUpload,this.id,this.token).subscribe((res:any)=>{
    if(res.status == 200){
      alert("Image Save successfull");
      this.getSingleHospital();
    }
  })
}else{
  alert('please fill all the required field')
}
}
// end add image
// delete images
showDeleteButton(){
  if(this.ShowDelete==false){
    this.ShowDelete = true;
  }else{
    this.ShowDelete = false;
  }
}
deleteImage(index:number){
  alert(index);
  this.hospitalService.DeleteHosImage(this.token,this.id,index).subscribe((res:any)=>{
    console.log("this is res of delete img",res);
    this.getSingleHospital();
    
  })
}
// end delete images

}
